import styles from "./AddressFieldPreView.module.css";
import addressOkImg from "../../img/ok_i.png";

/**
 * @author cjs
 * @date 2024-09-12 11:26:58
 * @remark 지도만들기 주소필드 미리보기 컴포넌트
 * @param none
 * @returns AddressFieldPreView
 */
function AddressFieldPreView() {
    return (
        <div className={styles.wrapAddressOkImg}>
            <img className={styles.addressOkImg} src={addressOkImg} alt="주소 확인 성공" />
        </div>
    );
}

export default AddressFieldPreView;
